import React from "react";
import BPDashboard from "../broker/BPDashboard";
import LODashboard from "../lo/LODashboard";
import BCError from "../BCError";
import { isValidPermission } from "../../Helpers";
import BPApplications from "../broker/BPApplications";
import { GlobalConstants } from "../constants/GlobalConstants";

const Home = ({ ...props }) => {
  return (
    <React.Fragment>
      {props.user.portal === GlobalConstants.Portals.BROKER && (isValidPermission(props.permissions, "BorrowerWhiteLabeledApplication", "read") || isValidPermission(props.permissions, "BrokerBorrowerApplication", "read")) ? <BPDashboard
        isGreaterThanMobile={props.isGreaterThanMobile}
        isGreaterThanTablet={props.isGreaterThanTablet}
        isSidebar={props.isSidebar}
        isMessage={props.isMessage}
        setIsMessage={props.setIsMessage}
        errorResponse={props.errorResponse}
        setErrorResponse={props.setErrorResponse}
        proxyUser= {props.proxyUser}
        permissions={props.permissions}
        brokerColor={props.brokerColor}
        isW9MessageVisible={props.isW9MessageVisible}
        setIsW9MessageVisible={props.setIsW9MessageVisible}
        user={props.user}
      /> : props.user.portal === GlobalConstants.Portals.BROKER && isValidPermission(props.permissions, "GuarantorWhiteLabeledApplication", "read") ?
      <BPApplications
        isGreaterThanMobile={props.isGreaterThanMobile}
        isGreaterThanTablet={props.isGreaterThanTablet}
        isSidebar={props.isSidebar} 
        applicationInfolist={props.applicationInfolist}
        setApplicationInfolist={props.setApplicationInfolist}
        isMessage={props.isMessage}
        setIsMessage={props.setIsMessage}
        errorResponse={props.errorResponse}
        setErrorResponse={props.setErrorResponse}
        user={props.user}
        proxyUser= {props.proxyUser}
        permissions={props.permissions}
        brokerColor={props.brokerColor}
        setCopiedApplicationId={props.setCopiedApplicationId}
      /> : props.user.portal === GlobalConstants.Portals.LOAN_OFFICER ? <LODashboard
        isGreaterThanMobile={props.isGreaterThanMobile}
        isGreaterThanTablet={props.isGreaterThanTablet}
        isSidebar={props.isSidebar}
        isMessage={props.isMessage}
        setIsMessage={props.setIsMessage}
        errorResponse={props.errorResponse}
        setErrorResponse={props.setErrorResponse}
      /> :
      <BCError
        isGreaterThanTablet={props.isGreaterThanTablet}
        isSidebar={props.isSidebar}
      />}
    </React.Fragment>
  );
};

export default Home;